import _ from 'lodash';

const EMAIL_REG_EXP=/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

function isValidEmail(email) {
 return _.isString(email) && EMAIL_REG_EXP.test(email);
}

export {
  isValidEmail
};
